export const SET_API_TOGGLE_INIT = 'SET_API_TOGGLE_INIT'
export const SET_API_TOGGLE_LOADING = 'SET_API_TOGGLE_LOADING'
export const SET_API_TOGGLE_SUCCESS = 'SET_API_TOGGLE_SUCCESS'
export const SET_API_TOGGLE_FAIL = 'SET_API_TOGGLE_FAIL'
export const SET_API_TOGGLE_EMPTY = 'SET_API_TOGGLE_EMPTY'
export const SET_API_DATA = 'SET_API_DATA'
export const SET_SDK_DATA = 'SET_SDK_DATA'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_COMMUNITY_INFO = 'SET_COMMUNITY_INFO'
export const SET_DIALOG_VISIBLE = 'SET_DIALOG_VISIBLE'
export const SET_TROLLEY = 'SET_TROLLEY'
export const INIT_TROLLEY = 'INIT_TROLLEY'
export const SET_SERVICE_INFO = 'SET_SERVICE_INFO'
export const SET_STORE_INFO = 'SET_STORE_INFO'
export const SET_CART = 'SET_CART'
